const stats = [
  { label: "可用线路", value: "4 条", highlight: false },
  { label: "平均延迟", value: "28ms", highlight: false },
  { label: "今日更新", value: "1 次", highlight: false },
  { label: "主线路状态", value: "畅通", highlight: true },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20and%20gold%20flowing%20gradient%20light%20waves%20on%20soft%20cream%20backdrop%2C%20minimalist%20elegant%20energy%20texture%2C%20smooth%20artistic%20digital%20art%2C%20plenty%20of%20negative%20space%2C%20no%20text&width=1920&height=1000&seq=jjsp-hero-01&orientation=landscape"
          alt="久久视频网址入口导航页面背景"
          title="久久视频官网入口 最新地址 防屏蔽"
          className="h-full w-full object-cover object-top opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/75 via-background-50/85 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1200px] flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="rise inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-radar-line"></i>
          </span>
          线路实时监测中 · 最近更新 2026-10-10
        </span>

        <h1 className="rise mt-6 max-w-4xl text-balance font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
          久久视频官网入口 · 最新防屏蔽地址大全
        </h1>

        <p className="rise mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          想找久久视频官网、最新地址与入口？本页整理防屏蔽网址与访问方式，解决网址失效问题。收藏本页即可随时获取稳定入口，免费影视追剧不再迷路。
        </p>

        <div className="rise mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#entrances"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-links-line"></i>
            </span>
            获取最新入口
          </a>
          <a
            href="#guide"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-book-open-line"></i>
            </span>
            查看访问指南
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-200 bg-background-50 p-4 text-left"
            >
              <dt className="text-xs text-foreground-500">{item.label}</dt>
              <dd
                className={`mt-1 font-heading text-xl font-bold ${
                  item.highlight ? "text-accent-600" : "text-foreground-950"
                }`}
              >
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}